import { toast } from '~/packages/Toast';
import type { TypeSafeTFunction } from '~/shared/hooks/useTranslation';

export const showUpsellSuccessToast = (t: TypeSafeTFunction) => {
  toast.success(t('upsells.successToast'));
};
